import { post } from '@/utils/request'

/**
 * 淘客获取自己没用过的新权限
 */
export default function taoke_module_new_list(data) {
  return post('taoke_module_new_list', data)
}